<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    水湾站<br>
站点介绍<br>
水湾站位于太子路与水湾路交叉路口的西侧，沿太子路正下方平行设置，车站大致呈东至西走向。车站临近南水步行街、海上世界等深圳著名商业中心及旅游景点，北侧有招商发展中心及两所重点学校：育才小学、育才中学。 该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:54	00:34	2号线	2分35秒	5分45秒<br>
莲塘	06:11	23:06	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:59	00:34	2号线	4分钟	5分钟<br>
莲塘	06:11	23:06	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:59	01:24	2号线	4分钟	5分钟<br>
莲塘	06:11	00:06	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
C出入口:<br>
太子路北侧(东)、水湾路、南水村、蛇口电视台、深圳市南山育才第一小学、深圳市南山育才中学、蛇口老街、花果山<br><br>
D出入口:<br>
太子路北侧（西）、荔园路、蛇口科技大厦、华府假日大厦、海滨花园、水湾1979广场<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 水湾地铁站<br>
226、331、M105、M106、M241、M400、M430、M519<br><br>
D出入口:<br>
公交站名： 水湾地铁站<br>
226、331、M105、M106、M241、M400、M430、M519<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>